import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexChart,
  ApexFill,
  ChartComponent,
  ApexStroke,
  ApexDataLabels
} from "ng-apexcharts";
import { ApexGrid, ApexLegend, ApexResponsive } from 'ng-apexcharts/public_api';
import { ScoreDetails } from 'src/app/all-motivations/model/all-motivations.interface';

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  grid: ApexGrid;
  labels: string[];
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  stroke: ApexStroke;
};

@Component({
  selector: 'app-score',
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.scss']
})
export class ScoreComponent implements OnInit {
  @Input() textSize:string = "24px";
  @Input() scoreValuesDetails: ScoreDetails;
  @Input() backgroundColor = "#FFFFFF";
  @Input() isMiniScoreView = false;
  @Input() isUnknownValue = false;
  showGrowthState:boolean = false;


  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: ChartOptions;
  label = "";
  hollowSize = "";
  offsetY = 0;
  chartScore = 0;

  constructor(public translate: TranslateService) {
  }

  ngOnInit(): void {
    if (this.scoreValuesDetails == undefined) {
      this.showGrowthState = true;
      return;
    }

    this.initView();
  }

  

  ngOnChanges(changes: SimpleChanges) {
    if (changes.scoreValuesDetails?.currentValue) {
      this.showGrowthState = !this.scoreValuesDetails || this.scoreValuesDetails.score === 0;
      if (!this.showGrowthState) {
        this.initView();
      }
    }

    if (changes.isUnknownValue != undefined && !changes.isUnknownValue.firstChange && 
      changes.isUnknownValue.currentValue != changes.isUnknownValue.previousValue) {
        this.initView();
    }
  }

  initView():void{
    // console.log('in Score:Initview');

    this.label = this.translate.instant("score.label")
    if (this.isUnknownValue){
      this.chartScore = 0;
    }
    else{
      this.chartScore = this.scoreValuesDetails.score;
    }

    if (this.isMiniScoreView){
      this.hollowSize = "80%";
      this.offsetY = 0;
    }
    else{
      this.hollowSize = "65%";
      this.offsetY = -10;
    }

    this.createChartOptions();
  }

  createChartOptions() : void{
    this.chartOptions = {
      series: [this.chartScore],
      chart: {
        type: "radialBar",
        // background: this.backgroundColor, way better without it
        toolbar: {
          show: false
        }
      },
      grid: {
        show: false,
        padding: {
          left: -20,
          right: 0,
          top:0,
          bottom:0
         }
      },
      plotOptions: {
        radialBar: {
          startAngle: -10,
          endAngle: 350,
          hollow: {
            margin: 0,
            size: this.hollowSize,
            background: this.backgroundColor,
            image: undefined,
            position: "front",
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24
            }
          },
          track: {
            background: "#EDEFF1",
            strokeWidth: "67%",
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: false,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35
            }
          },

          dataLabels: {
            show: true,
            name: {
              offsetY: this.offsetY,
              show: !this.isUnknownValue,
              color: "#888",
              fontSize: this.textSize
            },
            value: {
              formatter: function(val) {
                return parseInt(val.toString(), 10).toString();
              },
              offsetY: 5,
              color: "#111",
              fontSize: this.textSize,
              fontWeight: 600,
              show: !this.isUnknownValue
            }
          }
        }
      },
      fill: {
        colors: [
          function( value : any, seriesIndex:any, w:any ) {
            // console.log(`value is ${value}`);
            if (value > 50) {
              return '#f44336';
            } else if (value > 50 && value < 75) {
              return '#8bc34a';
            }
            else{
              return '#232D95';
            }
          }
        ]

    //   // fill: {
    //   //   type: "gradient",
    //   //   gradient: {
    //   //     shade: "dark",
    //   //     type: "horizontal",
    //   //     shadeIntensity: 0.5,
    //   //     gradientToColors: ["#8bc34a","#f44336","#cddc39"],
    //   //     inverseColors: true,
    //   //     opacityFrom: 1,
    //   //     opacityTo: 1,
    //   //     stops: [0,50, 100]
    //   //   }
      },
      stroke: {
        lineCap: "round"
      },
      labels: [this.label]
      
    };
  }
}